import { render, staticRenderFns } from "./CCustomSelectNativeSelect.vue?vue&type=template&id=4280887f&"
import script from "./CCustomSelectNativeSelect.vue?vue&type=script&lang=ts&"
export * from "./CCustomSelectNativeSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports